module.exports = __webpack_public_path__ + "static/img/icon4@2x.e8130b8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/activity/SPSR/icon4@2x.png
// module id = UeHF
// module chunks = 70